import { css } from '@emotion/css'
import { spacing, accessiblyHidden } from '@offerzen/pinata-shame'

const styles = {
  sendTermsBanner: css({
    marginBottom: spacing.large,
  }),

  notification: css({
    justifyContent: 'center',

    p: {
      margin: 0,
      padding: 0,
    },
  }),

  content: css({
    marginTop: spacing.large,
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles
